import COM from './Entry'

export default COM
